module.exports = __webpack_public_path__ + "static/media/Infra-Medium.15196275.otf";